import { formatter, request } from '@/utils/request';

export namespace SoldToGroup {
  export const Path = {
    Search: '/expenseapi/soldToGroup/search',
    AjaxSearch: '/expenseapi/soldToGroup/ajaxSearch',
    Query: '/expenseapi/soldToGroup/query',
    QueryForSheet: '/expenseapi/soldToGroup/queryForSheet',
    Get: '/expenseapi/soldToGroup/get',
    Post: '/expenseapi/soldToGroup/post',
    Delete: '/expenseapi/soldToGroup/delete',
    GetSoldToGroupToExcel:'/expenseapi/soldToGroup/getSoldToGroupToExcel',
    Export: '/expenseapi/soldToGroup/export',
    GetRelatedSoldTos: '/expenseapi/soldToGroup/getRelatedSoldTos',
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Query, formatter(options));
  }

  export async function search(body: API.SoldToGroupFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldToGroup[]>>(Path.Search, formatter(options));
  }
  export async function ajaxSearch(body: API.SoldToGroupFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldToGroup[]>>(Path.AjaxSearch, formatter(options));
  }
  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.SoldToGroup>>(Path.Get, formatter(options));
  }
  export async function post(body: API.SoldToGroupParam) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.SoldToGroupParam>>(Path.Post, formatter(options));
  }
  export async function del(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<any>>(Path.Delete, formatter(options));
  }


  export async function exportEx(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.Export, formatter(options));
  }

  export async function queryForSheet(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<any>>(Path.QueryForSheet, formatter(options));
  }

  export async function getRelatedSoldTos(soldToGroupId: number) {
    const options = {
      method: 'GET',
      body: {
        soldToGroupId: soldToGroupId,
      },
    };
    return request<API.ResponseResult<API.SoldToAndSoldToGroupVo[]>>(Path.GetRelatedSoldTos, formatter(options));
  }
}
